import { useEffect, useReducer } from 'react'
import { useSelector } from 'react-redux'
import { selectLatestRatesBidAsk } from '../../../../../store/redusers/assets/selectors'

function checkIsValidData (value, position, typeSlOrTp, lastPrice) {
	if (!lastPrice) {
		return true
	}
	if (position === 'sell') {
		if (typeSlOrTp === 'sl') {
			if (value < lastPrice) {
				//eslint-disable-next-line
				console.log(`cant be smaller current bid ${+lastPrice}`)
				return { isError: true, message: `cant be smaller current bid ${lastPrice}` }
			}
			// console.log(latestRatesBidAsk)
		}
		if (typeSlOrTp === 'tp') {
			// console.log('cant be bigger than current ask ')
		}
		return
	}
}

const initialState = {
	initialValue: '',
	slValue: '',
	tpValue: ''
}

const sLTpReducer = (state, action) => {
	switch (action.type) {
	case 'change_state':
		return {
			...state,
			...action.payload
		}
	default:
		return state
	}
}
function useSlTp (initialValue, assetId, position, typeSlOrTp, lastPrice) {
	const [state, dispatch] = useReducer(sLTpReducer, initialState)
	const latestRatesBidAsk = useSelector(selectLatestRatesBidAsk('asset_' + assetId))

	useEffect(() => {
		dispatch({
			payload: {
				initialValue
			},
			type: 'change_state'
		})
	}, [])

	useEffect(() => {
		if (!state.tempValue) {
			return
		}
		if (position === 'sell') {
			if (typeSlOrTp === 'sl') {
				// console.log('cant be smaller open task')
				// console.log(latestRatesBidAsk)
			}
			if (typeSlOrTp === 'tp') {
				// console.log('cant be bigger than current ask ')
			}
			return
		}
		if (position === 'buy') {
			if (typeSlOrTp === 'sl') {
				// console.log(latestRatesBidAsk)
			}
			if (typeSlOrTp === 'tp') {
				// console.log(latestRatesBidAsk)
			}
		}
	}, [latestRatesBidAsk])


	const updateValue = (event) => {
		let value =  event.target.value ? event.target.value : 0
		if (value) {
			value = value.replace('/', '.')
			value = value.replace(',', '.')
			const splitString = value.slice().split('');
			if (splitString.length > 1 && splitString[1] !== '.' && splitString[0] === '0') {
				value = +value.toString()
			}
		}
		if (isNaN(value)) {
			return
		}
		checkIsValidData(value, position, typeSlOrTp, lastPrice)
		if (!value) {
			dispatch({
				payload: {
					tempValue: '0'
				},
				type: 'change_state'
			})
			return
		}
		dispatch({
			payload: {
				tempValue: value
			},
			type: 'change_state'
		})
	}

	const updateValueChart = (value) => {
		dispatch({
			payload: {
				tempValue: value
			},
			type: 'change_state'
		})
	}


	const returnInitialState = () => {
		dispatch({
			payload: {
				initialValue: '',
				tempValue: null
			},
			type: 'change_state'
		})
	}

	return [
		state,
		{
			returnInitialState,
			updateValue,
			updateValueChart
		}
	]
}

export default useSlTp
